import { HTMLAttributes, PropsWithChildren } from "react"
import { HeaderProps } from "react-table"
import { CSS, CSSFn, styled, StyleProps, callCSSFn } from "../../styles"
import { Align } from "../types"

type Props<T extends {}> = HeaderProps<T> & {
  dataTestId?: string
  className?: string
  align?: Align
}
export type TableHeadCellProps = HTMLAttributes<HTMLTableElement> & {
  css?: CSSFn
}
const Component = <T extends {}>({ dataTestId, className, align, children }: PropsWithChildren<Props<T>>) => {
  let classNames = `${className} rmwc-data-table__cell mdc-data-table__header-cell`
  classNames += align === `end` ? ` rmwc-data-table__cell--align-end` : ` rmwc-data-table__cell--align-start`
  return (
    <th data-testid={dataTestId} className={classNames}>
      {children}
    </th>
  )
}

Component.defaultProps = {
  dataTestId: undefined,
  align: `start`,
  className: undefined,
}

export const TableHeadCell = styled(Component)(
  (props: StyleProps): CSS => ({
    height: `auto`,
    fontSize: props.theme.fontSize.caption,
    color: props.theme.palette.coal.dark,
    fontWeight: `bold`,
    textTransform: `none`,
    position: `relative`,
    ...callCSSFn(props),
  })
)
